// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4b20ba59","648":"5682d048","793":"29db9f89"}[chunkId] + ".chunk.js";
};